import { useTour } from "@reactour/tour";
import { BsQuestionCircleFill } from "react-icons/bs";

export default function Tour() {
  const { setIsOpen } = useTour();

  return (
    <div
      style={{
        display: "flex",
        width: "95%",
        alignItems: "flex-end",
        justifyContent: "end",
        marginTop: "11rem",
        marginBottom: '1.5rem'
      }}
    >
      <BsQuestionCircleFill
        className=" cursor-pointer w-11 h-11"
        onClick={() => setIsOpen(true)}
      ></BsQuestionCircleFill>
    </div>
  );
}
